<script setup lang="ts">
import { computed } from 'vue';
import ActiveBenchmarkGauge from './ActiveBenchmarkGauge.vue';
import ActiveBenchmarkDrivers from './ActiveBenchmarkDrivers.vue';
import type { ActiveProgramData } from '@Shared/types/portal/BenchmarkInterfaces';

interface ActiveProgram {
  data: ActiveProgramData;
  index: number;
  maxDriverCount: number;
}

const activeProgram = defineProps<ActiveProgram>();
const activeProgramData = computed(() => activeProgram.data);

const getActiveBenchmarkProgramGaugeId = (index: number) => `active-program-gauge-${index}`;
const getActiveBenchmarkProgramDriverId = (index: number) => `active-program-gauge-${index}`;
</script>

<template>
  <div class="flex flex-col gap-8 items-center w-full">
    <!-- Gauge Component -->
    <div class="flex justify-center w-full">
      <div class="w-full max-w-2xl">
        <ActiveBenchmarkGauge
          :index="activeProgram.index"
          :title="activeProgramData.programFriendlyName ?? ''"
          :tenant-primary-metric-score="activeProgramData.tenantPrimaryMetricScore"
          :benchmark-primary-metric-score="activeProgramData.benchmarkPrimaryMetricScore"
          :percentile="activeProgramData.percentile"
          :id="getActiveBenchmarkProgramGaugeId(index)"
        />
      </div>
    </div>

    <!-- Drivers Component -->
    <div class="flex justify-center w-full">
      <div class="w-full max-w-2xl">
        <ActiveBenchmarkDrivers
          :index="activeProgram.index"
          :drivers="activeProgramData.drivers"
          :max-driver-count="maxDriverCount"
          :id="getActiveBenchmarkProgramDriverId(index)"
        />
      </div>
    </div>
  </div>
</template>
